import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const ADMIN_ORDERS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    // Order List & Management
    ORDERS_INDIVIDUAL: '/admin/orders/individual/',
    ORDERS_BUSINESS: '/admin/orders/business/',
    FINANCE_ORDERS: '/finance-orders',
    ADMIN_ORDERS: '/admin-orders/',
    ADMIN_ORDER_DETAIL: (id: number) => `/admin-orders/${id}/`,
    MAIN_ORDERS: '/admin/main-orders/',
    CLIENT_GOALS: '/client-goal-choices/',
    // Order Messages & Communication
    ORDER_MESSAGES_LOG: (orderId: number) => `/admin-order-messages-log/${orderId}/`,
    DELETE_ORDER_MESSAGE: (msgPK: number) => `/admin-delete-order-messages-log/${msgPK}/`,
    
    // Order Payment & Financial
    ORDER_COST_IS_RECEIVED: (orderID: number) => `/order-cost-is-received/${orderID}/`,
    INSPECTOR_SHARE_IS_PAID: '/inspector-share-is-paid/',
    INSPECTOR_SHARE_IS_PAID_DETAIL: (orderID: number) => `/inspector-share-is-paid/${orderID}/`,
    ORDER_PURCHASE: (id: number) => `/admin/orders/${id}/purchase/`,
    ORDER_REFUND: (orderId: number) => `/admin/orders/${orderId}/refund`,
    
    // Order Operations
    ORDER_BOOL: (orderId: number) => `/admin/order_bool/${orderId}/`,
    COUPON_APPLY: '/coupon-apply/',
    LINK_ORDERS: (linkedOrderId: number) => `/admin/orders/${linkedOrderId}/link-orders/`,
    UNLINK_ORDERS: '/admin/unlink-orders/',
    BULK_UPDATE_ORDER_STATUS: '/bulk-update-order-status/',
    DUPLICATE_ORDER: '/admin/duplicate-order/',
    
    // Reinspection Orders
    CREATE_REINSPECTION_ORDER: '/admin/orders/create-reinspection-order/',
    REINSPECTION: (orderId: number) => `/admin/orders/${orderId}/reinspection/`,
    
    // Order Grid & Display
    ORDER_GRID_COLUMN: '/admin/order-grid-column/',
    
    // Order Status & Sync
    SET_SYNC_STATUS_READY: (orderId: number) => `/admin/set-sync-status-ready/${orderId}/`,
    BULK_REASSIGN_QC: '/admin/bulk-reassign-qc',
    
    // Order Analytics & Summary
    VISIT_SUMMARY: (id: number) => `/admin-ayen-visit-summary/${id}`,
    
    // Integration & Export
    ZAPIER_SEND_MANUALLY: (id: number) => `/zapier/send_manually/${id}/`,
    SEND_ORDER_DATA_TO_QOYOD: (orderId: number) => `/admin/send-order-data-to-qoyod/${orderId}/`,
    QOYOOD_INVOICES: (orderId: number) => `/admin/qoyood-invoices/${orderId}/`,
    FINANCE_EXPORT_EXCEL: '/finance-export-excel/',

  }),

   v2: createEndpoints('v2', {
    // Property Relations
    PROPERTY_RELATIONS: '/property-relations/',
  }),
} as const;
